import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal, Input, Space, Form, Typography, Divider, message } from 'antd'
import styles from './style.module.css'
import { createActualItem } from '../../../services/application'
import DecimalInput from '../../DecimalInput'
import { formatDecimalAmount } from '../../../utils/number-utils'

const { Text } = Typography

const renderEstimateItem = (item) =>
  item?.estimate_field
    ? `${item?.estimate_field?.name} / ${item?.estimate_field?.category} / Цена: ${
        item?.estimate_field?.price || '-'
      } ${item?.estimate_field?.unit ? item?.estimate_field?.unit : ''}`
    : `${item?.category ? item?.category : '-'}`

const renderApplicationItem = (item) =>
  item
    ? `${item.name}, ${formatDecimalAmount(item.amount)} ${item.unit} ${
        item.description ? `(примечание: ${item.description})` : ''
      }`
    : ''

const renderImplementationItem = (item) =>
  item
    ? `${item.name}, ${formatDecimalAmount(item.amount)} ${item.unit} ${
        item.correctedAmount
          ? `корректировка кол-ва: ${formatDecimalAmount(item.correctedAmount)} ${item.estimate?.unit}`
          : ''
      } ${item.description ? `(примечание: ${item.description})` : ''}`
    : ''

const ActualAmountModal = ({ application, showModal, onChancel, onUpdate }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  Form.useWatch('implementation', form)

  useEffect(() => {
    form.resetFields()
  }, [application?.id])

  const initFields = useMemo(
    () =>
      application?.implementation
        ? {
            implementation: application?.implementation?.implementation_items?.map((item) => ({
              id: item.id,
              name: item.name,
              amount: item.amount,
              unit: item.unit,
              description: item.description,
              actualAmount: item.actualAmount || item.correctedAmount || item.amount,
              actualDescription: item.actualDescription,
              correctedAmount: item.correctedAmount,
              estimate: application.application_items.find(
                (applicationItem) => applicationItem.id === item?.application_item?.id
              ),
              actualApplicationItem: item?.actual_application_item?.id,
            })),
          }
        : {},
    [application?.id]
  )

  const onUpdateHandler = (key) => {
    const implementation = form.getFieldValue('implementation')[key]
    const data = {
      actual: {
        id: implementation.id,
        amount: implementation.actualAmount,
      },
      applicationItem: {
        name: implementation.estimate?.name,
        description: implementation.estimate?.description,
        unit: implementation.estimate?.unit,
        amount: implementation?.estimate?.amount - implementation.actualAmount,
        estimate_field: implementation.estimate?.estimate_field?.id,
        category: implementation.estimate?.category,
        off_budget: implementation.estimate?.off_budget,
        project: implementation.estimate?.project?.id,
      },
    }
    createActualItem(data)
      .then((response) => {
        if (response?.data?.newItem) {
          const implementations = form.getFieldValue('implementation')
          Object.assign(implementations[key], { actualApplicationItem: response?.data?.newItem?.id })
          form.setFieldValue('implementation', implementations)
        }
        onUpdate()
        message.success('Заявка на остаток успешно добавлена')
      })
      .catch(() => {
        message.error('Ошибка добавления заявки на остаток')
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Modal
      title="Поэтапная приемка"
      visible={showModal}
      onCancel={onChancel}
      footer={[
        <Button key="back" onClick={onChancel} disabled={isLoading}>
          Закрыть
        </Button>,
      ]}
    >
      <Form initialValues={initFields} name="application" layout="horizontal" form={form}>
        <Form.List name="implementation">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => {
                const implementation = form.getFieldValue('implementation')[key]
                const actualAmount = implementation?.actualAmount
                const estimateAmount = implementation?.estimate?.amount
                const estimateUnit = implementation?.estimate?.unit
                const actualApplicationItem = implementation?.actualApplicationItem
                return (
                  <div key={key}>
                    <Space className={styles.info} size={0}>
                      <div>
                        <Text strong>Заявка: </Text>
                        <Text>{renderApplicationItem(implementation?.estimate)}</Text>
                      </div>
                      <div>
                        <Text strong>Снабжение: </Text>
                        <Text type={implementation?.correctedAmount && 'danger'}>
                          {renderImplementationItem(implementation)}
                        </Text>
                      </div>
                      <div>{implementation?.isDetalisation && <Text type="danger">Детализация</Text>}</div>
                    </Space>
                    <Form.Item style={{ display: 'none' }} {...restField} name={[name, 'id']} hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item {...restField} label="Фактическое количество" name={[name, 'actualAmount']}>
                      <DecimalInput disabled={actualApplicationItem} style={{ minWidth: 200 }} />
                    </Form.Item>
                    {actualAmount < estimateAmount && !actualApplicationItem && (
                      <Form.Item>
                        <Button disabled={isLoading} type="dashed" onClick={() => onUpdateHandler(key)} block>
                          Создать заявку на остаток: {estimateAmount - actualAmount} {estimateUnit}
                        </Button>
                      </Form.Item>
                    )}
                    <Divider plain />
                  </div>
                )
              })}
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  )
}

export default ActualAmountModal
